export interface KnowledgeNode {
  id: string;
  name: string;
  type: "scene" | "culture" | "history" | "person" | "nature" | "engineering";
  description: string;
  relatedCount: number;
  confidence: number;
  source: string;
}

export interface KnowledgeEdge {
  id: string;
  from: string;
  to: string;
  relation: string;
  weight: number;
}

export const knowledgeStats = {
  totalNodes: 156,
  totalEdges: 423,
  autoExtracted: 98,
  manualReviewed: 58,
  lastUpdated: "2026-06-01 10:00:00",
};

export const knowledgeNodes: KnowledgeNode[] = [
  { id: "1", name: "三峡大坝", type: "engineering", description: "世界最大水利枢纽，坝高185米，装机容量2250万千瓦", relatedCount: 28, confidence: 0.98, source: "工程资料" },
  { id: "2", name: "西陵峡", type: "nature", description: "长江三峡中最长的峡谷，全长66公里，以滩多水急著称", relatedCount: 22, confidence: 0.95, source: "地理资料" },
  { id: "3", name: "葛洲坝", type: "engineering", description: "长江第一座大型水利枢纽，1981年建成，坝高47米", relatedCount: 18, confidence: 0.97, source: "工程资料" },
  { id: "4", name: "屈原", type: "person", description: "战国时期楚国诗人，代表作《离骚》《九歌》，端午节纪念人物", relatedCount: 15, confidence: 0.96, source: "史料" },
  { id: "5", name: "白帝城", type: "history", description: "刘备托孤之地，李白\"朝辞白帝彩云间\"，三国文化遗址", relatedCount: 14, confidence: 0.94, source: "史料" },
  { id: "6", name: "巫山神女峰", type: "nature", description: "巫山十二峰之最，传说为瑶姬所化，云雾缭绕时若隐若现", relatedCount: 13, confidence: 0.92, source: "民间传说" },
  { id: "7", name: "黄牛岩", type: "nature", description: "相传大禹治水时神牛助其开山，石牌要塞旁的著名景点", relatedCount: 11, confidence: 0.89, source: "民间传说" },
  { id: "8", name: "石牌要塞", type: "history", description: "二战时期石牌保卫战发生地，被誉为\"东方斯大林格勒\"", relatedCount: 12, confidence: 0.93, source: "史料" },
  { id: "9", name: "三游洞", type: "culture", description: "唐代白居易、白行简、元稹三人同游而得名，钟乳石奇特", relatedCount: 10, confidence: 0.91, source: "史料" },
  { id: "10", name: "南津关", type: "history", description: "长江三峡的东大门，西陵峡终点，自古为兵家必争之地", relatedCount: 9, confidence: 0.90, source: "地理资料" },
  { id: "11", name: "中华鲟", type: "nature", description: "长江珍稀鱼类，三峡库区建有鱼类增殖放流站", relatedCount: 16, confidence: 0.94, source: "生态资料" },
  { id: "12", name: "大禹治水", type: "history", description: "上古神话，大禹疏通长江三峡，黄牛岩传说与此相关", relatedCount: 8, confidence: 0.85, source: "民间传说" },
  { id: "13", name: "李白", type: "person", description: "唐代诗人，\"朝辞白帝彩云间\"描写白帝城晨景", relatedCount: 7, confidence: 0.93, source: "史料" },
  { id: "14", name: "兵书宝剑峡", type: "culture", description: "相传诸葛亮藏兵书于石壁，宝剑化为宝剑峰", relatedCount: 6, confidence: 0.82, source: "民间传说" },
  { id: "15", name: "秭归", type: "history", description: "屈原故里，每年端午节举行龙舟竞渡和祭祀", relatedCount: 11, confidence: 0.91, source: "史料" },
  { id: "16", name: "长江航运", type: "history", description: "三峡段自古重要航运通道，历史上被称为\"鬼门关\"", relatedCount: 8, confidence: 0.88, source: "航运志" },
  { id: "17", name: "葛洲坝电站", type: "engineering", description: "葛洲坝配套水电站，发电量支撑华中地区", relatedCount: 7, confidence: 0.90, source: "工程资料" },
  { id: "18", name: "瑶姬", type: "person", description: "炎帝之女，传说化为巫山神女峰", relatedCount: 6, confidence: 0.79, source: "民间传说" },
  { id: "19", name: "诸葛亮", type: "person", description: "三国时期蜀汉丞相，兵书宝剑峡传说与之相关", relatedCount: 5, confidence: 0.84, source: "史料" },
  { id: "20", name: "白鹤梁", type: "culture", description: "长江水下碑林，记录了1200年的长江水位", relatedCount: 7, confidence: 0.87, source: "文物资料" },
];

export const knowledgeEdges: KnowledgeEdge[] = [
  { id: "1", from: "1", to: "2", relation: "地理位置", weight: 0.95 },
  { id: "2", from: "1", to: "3", relation: "上下游关系", weight: 0.92 },
  { id: "3", from: "4", to: "15", relation: "出生于此", weight: 0.98 },
  { id: "4", from: "5", to: "13", relation: "诗歌描写", weight: 0.94 },
  { id: "5", from: "6", to: "18", relation: "传说化身", weight: 0.85 },
  { id: "6", from: "7", to: "12", relation: "传说相关", weight: 0.88 },
  { id: "7", from: "8", to: "7", relation: "相邻景点", weight: 0.90 },
  { id: "8", from: "9", to: "4", relation: "文化关联", weight: 0.76 },
  { id: "9", from: "2", to: "10", relation: "峡谷终点", weight: 0.93 },
  { id: "10", from: "1", to: "11", relation: "生态保护", weight: 0.89 },
  { id: "11", from: "14", to: "19", relation: "传说关联", weight: 0.82 },
  { id: "12", from: "16", to: "2", relation: "经过此处", weight: 0.91 },
  { id: "13", from: "3", to: "17", relation: "包含设施", weight: 0.90 },
  { id: "14", from: "5", to: "4", relation: "历史关联", weight: 0.78 },
  { id: "15", from: "20", to: "1", relation: "淹没保护", weight: 0.86 },
];

export const typeLabels: Record<string, string> = {
  scene: "景点",
  culture: "文化",
  history: "历史",
  person: "人物",
  nature: "自然",
  engineering: "工程",
};

export const typeColors: Record<string, string> = {
  scene: "bg-teal-100 text-teal-700",
  culture: "bg-amber-100 text-amber-700",
  history: "bg-red-100 text-red-700",
  person: "bg-blue-100 text-blue-700",
  nature: "bg-emerald-100 text-emerald-700",
  engineering: "bg-gray-100 text-gray-700",
};

export const relationColors: Record<string, string> = {
  "地理位置": "#0d9488",
  "上下游关系": "#0d9488",
  "出生于此": "#f59e0b",
  "诗歌描写": "#8b5cf6",
  "传说化身": "#ec4899",
  "传说相关": "#ec4899",
  "相邻景点": "#0d9488",
  "文化关联": "#f59e0b",
  "峡谷终点": "#0d9488",
  "生态保护": "#10b981",
  "包含设施": "#6b7280",
  "历史关联": "#ef4444",
  "淹没保护": "#6b7280",
  "经过此处": "#0d9488",
};